var _path, _path2, _g, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 190,
    viewBox: "0 0 226 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.316 133.954C205.316 123.334 214.304 114.703 225.412 114.703L225.412 78C193.148 78 167 103.047 167 133.954C167 164.861 193.148 189.908 225.412 189.908L225.412 153.205C214.326 153.205 205.316 144.595 205.316 133.954Z",
    fill: "#EE7F25"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3118_30968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 78,
    width: 59,
    height: 112
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.165 133.733C205.165 123.157 214.117 114.561 225.18 114.561L225.18 78.0073C193.046 78.0073 167.006 102.952 167.006 133.733C167.006 164.514 193.046 189.459 225.18 189.459L225.18 152.905C214.139 152.905 205.165 144.331 205.165 133.733Z",
    fill: "#E43625"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3118_30968)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.87 -20.5352L225.711 78.1207",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 -13.9531L225.703 84.7028",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 -7.38477L225.703 91.2711",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.878 -0.808602L225.719 97.8473",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 5.75585L225.703 104.412",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 12.3379L225.703 110.994",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 18.9121L225.703 117.568",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.878 25.4902L225.719 124.146",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87 32.0644L225.711 130.72",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87 38.6641L225.711 137.32",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.878 45.2246L225.719 143.88",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 51.8203L225.703 150.476",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 58.3769L225.703 157.033",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 64.9551L225.703 163.611",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87 71.5371L225.711 170.193",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 78.1094L225.703 176.765",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.878 84.6973L225.719 183.353",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.862 91.2598L225.703 189.916",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.847 97.8457L225.687 196.502",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87 104.428L225.711 203.084",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.854 111.006L225.695 209.662",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87 117.572L225.711 216.228",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.058 133.635L225.898 232.291",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.854 130.723L225.695 229.379",
    stroke: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.073 80.2143C129.837 79.6608 126.523 79.75 123.322 80.477C120.12 81.204 117.093 82.5544 114.413 84.4512C111.734 86.348 109.454 88.754 107.704 91.5319C105.954 94.3098 104.769 97.4051 104.215 100.641C103.662 103.877 103.751 107.191 104.478 110.392C105.205 113.594 106.555 116.621 108.452 119.3C110.349 121.98 112.755 124.26 115.533 126.01C118.311 127.759 121.406 128.945 124.642 129.498L128.857 104.856L133.073 80.2143Z",
    fill: "#FFCE1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225 15.6488V43C201.263 43 182 23.7565 182 0H209.351C209.351 8.63517 216.365 15.6488 225 15.6488Z",
    fill: "#3091D0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 150.5,
    r: 8.5,
    fill: "#6F368B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink14);
export default __webpack_public_path__ + "static/media/Link14.b1f06da0ecf764ae6bb7dca466d0efed.svg";
export { ForwardRef as ReactComponent };